import { render, staticRenderFns } from "./StatisticsConnectionRenderer.vue?vue&type=template&id=39b7a90a&scoped=true&"
import script from "./StatisticsConnectionRenderer.vue?vue&type=script&lang=ts&"
export * from "./StatisticsConnectionRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticsConnectionRenderer.vue?vue&type=style&index=0&id=39b7a90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b7a90a",
  null
  
)

export default component.exports